import * as React from 'react';
export const IcHairProblems = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.84 15.08l.18.16a2.69 2.69 0 001.86.76H12a3 3 0 002.92-2.33c.049-.22.076-.444.08-.67 0-.201-.02-.402-.06-.6a7.887 7.887 0 00-.47-1.4 4.64 4.64 0 01.24-4.78c.36-.55.74-1.08 1.1-1.6a1 1 0 00-1.59-1.2A14.822 14.822 0 0013.08 5C11.44 7.41 9 11.27 9 12.86V13a3 3 0 00.84 2.08zM20 11h-3.42A5 5 0 117 13c0-.689.142-1.37.42-2H4a2 2 0 00-2 2v5a2 2 0 002 2h16a2 2 0 002-2v-5a2 2 0 00-2-2z'
      fill='currentColor'
    />
  </svg>
);
